import { render, staticRenderFns } from "./ChatOrderPaymentDetail.vue?vue&type=template&id=090ebdc3&scoped=true&"
import script from "./ChatOrderPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./ChatOrderPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderPaymentDetail.vue?vue&type=style&index=0&id=090ebdc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ebdc3",
  null
  
)

export default component.exports